"use client"
import React, { useState } from "react"
import { useBilling } from "../../../../../context/BillingContext"
import { toast } from "react-toastify";
import { useRazorpay } from "../../../../../context/RazorpayContext";

const UpgradeModal = ({ show, onClose,openModal }) => {
  const { plans } = useBilling();
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [upgradeLoader, setUpgradeLoader] = useState(false);
  const { handlePreviewPlan } = useRazorpay();

  if (!show) return null

// Find the index of the current plan
const currentPlanIndex = plans?.findIndex((plan) => plan.current);
const currentPlan = plans?.[currentPlanIndex];


  // Filter out only higher plans
  const availablePlans = plans?.filter(plan => !plan.current)

  // const availablePlans = plans?.slice(currentPlanIndex + 1)

  const closeModal = () => {
    setSelectedPlanId(null);
    onClose()
  }

        const parsePrice = (price) => {
      if (!price) return 0;
      return parseFloat(price.replace(/[₹,\s]/g, ""));
    };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      const selectedPlan = plans?.find(plan => plan.id === selectedPlanId);

    if (!selectedPlan || !currentPlan) {
      toast.error("Unable to determine selected or current plan details");
      return;
    }


    const selectedPrice = selectedPlan.price === "Free" ? 0 : parsePrice(selectedPlan.price);
    const currentPrice = parsePrice(currentPlan.price);

    // Compare prices — replace 'price' with your actual price key if different
    const isDowngrade = selectedPrice < currentPrice;

    if (isDowngrade) {
      openModal("downgrade", { selectedPlanId });
    } 
      else{
        setUpgradeLoader(true)
        await handlePreviewPlan(e, selectedPlanId, 'upgrade');
        setSelectedPlanId(null);
        closeModal();
      }
    }
    catch (err) {
      const errorMessage = err?.response?.data?.message || err?.response?.data?.error || err?.message || "Failed to upgrade the plan";
      toast.error(errorMessage, {
        position: 'bottom-right',
        autoClose: 5000,
      })
    }
    finally {
      setUpgradeLoader(false)
    }
  }
  

  return (
    <div
      className="modal d-flex"
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 1052,
      }}
      onClick={closeModal}
    >
      <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header border-bottom">
            <h5 className="modal-title fw-semibold">Update Your Plan</h5>
            <div className="modal-close-btn">
              <button type="button" className="btn-close" onClick={closeModal}></button>
            </div>
          </div>

          <div className="modal-body package-modal">
            <div className="text-center mb-4">
              <h6 className="fw-semibold mb-2">Choose Your New Plan</h6>
              <p className="text-muted">Select the plan that best fits your needs</p>
            </div>

            {availablePlans?.length > 0 ? (
              availablePlans.map((plan, index) => {
                const formattedDescription = plan?.description
                  ?.replace(/\\u003c/g, "<")
                  ?.replace(/\\u003e/g, ">");

                const descriptionPoints = formattedDescription
                  ?.split("\n")
                  ?.filter((line) => line.trim() !== "");

                return (
                  <div className="mb-3" key={index}>
                    <label className="d-flex align-items-center p-3 border rounded cursor-pointer w-100">
                      <input
                        onChange={() => setSelectedPlanId(plan.id)}
                        type="radio"
                        name="upgrade-plan"
                        checked={plan.id === selectedPlanId}
                        className="me-3"
                      />
                      <div className="flex-fill">
                        <div className="d-flex justify-content-between">
                          <div>
                            <div className="fw-semibold">{plan.name} Plan</div>
                            <ul
                              className="sc-eYFTNc juiKPo "
                              style={{ marginTop: "8px", paddingLeft: "18px" }}
                            >
                              {descriptionPoints?.map((point, i) => {
                                const hasBold = /<b>/i.test(point); // check if <b> tag exists
                                return (
                                  <li
                                    key={i}
                                    style={hasBold ? { listStyleType: "none", paddingLeft: "0" } : {}}
                                    dangerouslySetInnerHTML={{ __html: point }}
                                  ></li>
                                );
                              })}
                            </ul>
                          </div>

                          <div className="text-end">
                            <div className="fw-bold">{ plan?.price ==='Free' ? <h5 className="fw-bold">Free</h5>: `${plan?.price}/${plan?.interval}`}</div>
                            <small className="text-success">
                              {/* +${plan.price - plans[currentPlanIndex]?.price} from current */}
                            </small>
                          </div>
                        </div>

                        {plan?.features && (
                          <ul className="mt-2 mb-0 small text-muted upgrade-modal-feature-list">
                            {plan.features.map((feature, i) => (
                              <li key={i}>{feature}</li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </label>
                  </div>
                );
              })
            ) : (
              <p className="text-center text-muted">
                You are already on the highest plan 🎉
              </p>
            )}
          </div>


          <div className="modal-footer">
            <button className="btn btn-outline-secondary flex-fill" disabled={upgradeLoader} onClick={closeModal}>
              Cancel
            </button>
            <button className="btn plan-detail-card-btn flex-fill" disabled={!selectedPlanId || upgradeLoader} onClick={handleSubmit}>
              {upgradeLoader ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Processing your request...
                </>
              ) : <>Continue</>
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpgradeModal